import { render, staticRenderFns } from "./PersonSelectOpportunity.vue?vue&type=template&id=669adde1"
import script from "./PersonSelectOpportunity.vue?vue&type=script&lang=js"
export * from "./PersonSelectOpportunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports